import { Shield, Clock, MapPin, CreditCard, Star, Smartphone } from 'lucide-react';

const Features = () => {
  const features = [
    {
      icon: <Shield className="w-6 h-6" />,
      title: 'Verified & Licensed Barbers',
      description: 'All our barbers are professionally trained and background-checked'
    },
    {
      icon: <Clock className="w-6 h-6" />,
      title: 'Same-day & Next-day Availability',
      description: 'Book instantly or schedule for later at your convenience'
    },
    {
      icon: <MapPin className="w-6 h-6" />,
      title: 'Home or Office Convenience',
      description: 'Get groomed wherever you are - we come to you'
    },
    {
      icon: <Smartphone className="w-6 h-6" />,
      title: 'Transparent Pricing & Live Tracking',
      description: 'Know your cost upfront and track your barber in real-time'
    },
    {
      icon: <Star className="w-6 h-6" />,
      title: '100% Satisfaction Guarantee',
      description: 'Not happy? We\'ll make it right or refund your money'
    },
    {
      icon: <CreditCard className="w-6 h-6" />,
      title: 'Cash or Card Payment',
      description: 'Pay however you prefer - cash, card, or mobile money'
    }
  ];

  return (
    <section data-testid="features-section" className="section bg-[var(--bg-primary)] dark:bg-[#111111]">
      <div className="container">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[var(--text-primary)] mb-4" data-testid="features-heading">
            Why choose BarberGo?
          </h2>
          <p className="text-base text-[var(--text-secondary)] leading-relaxed">
            We're committed to delivering the best grooming experience right to your doorstep.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="features-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              data-testid={`feature-card-${index}`}
              className="group bg-[var(--bg-secondary)] dark:bg-[#1A1A1A] border border-[var(--border-color)] rounded-lg p-6 hover:border-[#00C167] transition-all duration-300 hover:-translate-y-1"
            >
              {/* Icon */}
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#00C167]/10 text-[#00C167] mb-4 group-hover:bg-[#00C167] group-hover:text-white transition-colors">
                {feature.icon}
              </div>

              {/* Content */}
              <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-[var(--text-secondary)]">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;